export const GET_SETTINGS = 'HOSPITALS/get_settings';
export const GET_SINGLE_SETTING = 'HOSPITALS/get_single_setting';
export const UPDATE_SETTING = 'HOSPITALS/update_setting';
export const CREATE_SETTING = 'HOSPITALS/create_setting';
export const REMOVE_SETTING = 'HOSPITALS/remove_setting';

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  name: '',
};
